import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Layouts
import DashboardLayout from './components/DashboardLayout';

// Pages
import Login from './pages/Login';
// import ForgotPassword from './pages/ForgotPassword';
import SetPassword from './pages/SetPassword';
import DashboardHome from './pages/DashboardHome';
import UserManagement from './pages/UserManagement';
import CustomerManagement from './pages/CustomerManagement';
import DeviceManagement from './pages/DeviceManagement';
import AddCustomer from './pages/AddCustomer';
import EditCustomer from './pages/EditCustomer';
import AddUser from './pages/AddUser';
import EditUser from './pages/EditUser';
import EntityManagement from './pages/EntityManagement';
import ClientManagement from './pages/ClientManagement';
import AddEditEntity from './pages/AddEditEntity';
import AddEditClient from './pages/AddEditClient';
import Reports from './pages/Reports';

// --- NEW: Protected Route Wrapper ---
// This component checks if a token exists. If not, it redirects to Login.
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  
  if (!token) {
    // User is not logged in, redirect to login page
    return <Navigate to="/login" replace />;
  }
  
  // User is authenticated, render the child component (Dashboard)
  return children;
};

const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/verify-email" element={<SetPassword />} />
                {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}

                {/* Protected Dashboard Routes */}
                {/* All these routes share the DashboardLayout (Header + Content) */}
                <Route path="/" element={
                    // Wrap the layout in ProtectedRoute
                    <ProtectedRoute>
                        <DashboardLayout />
                    </ProtectedRoute>
                }>
                    <Route index element={<DashboardHome />} />

                    {/* Entity Module */}
                    <Route path="entity" element={<EntityManagement />} />
                    <Route path="entity/new" element={<AddEditEntity />} />
                    <Route path="entity/edit/:id" element={<AddEditEntity />} />

                    {/* Client Module */}
                    <Route path="client" element={<ClientManagement />} />
                    <Route path="client/new" element={<AddEditClient />} />
                    <Route path="client/edit/:id" element={<AddEditClient />} />
                    
                    {/* User Module */}
                    <Route path="users" element={<UserManagement />} />
                    <Route path="users/new" element={<AddUser />} />
                    <Route path="users/edit/:id" element={<EditUser />} />

                    {/* Customer Module */}
                    <Route path="customers" element={<CustomerManagement />} />
                    <Route path="customers/new" element={<AddCustomer />} />
                    <Route path="customers/edit/:id" element={<EditCustomer />} />

                    {/* Device Module */}
                    <Route path="devices" element={<DeviceManagement />} />

                    {/* Reports Module */}
                    <Route path="reports" element={<Reports />} />
                </Route>

                {/* Catch-all Redirect: Send unknown URLs to login */}
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppRouter;